import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import * as feather from 'feather-icons';
import { ApiService } from 'src/app/api.service';
import { AppComponent } from 'src/app/app.component';
import { ThemingService, ShopTheming } from 'src/app/theming.service';
import { environment } from 'src/environments/environment';
import { LambdaService } from 'src/app/lambda.service';
import { getFileExtension } from 'src/app/helpers/util';
import {
  buildProductFilesPayload,
  createEmptyProductPdfFile,
  normalizeProductFiles,
  PDF_MAX_SIZE_BYTES,
  ProductPdfFile,
  ProductPdfFilePayload,
  validateProductPdfFiles,
} from 'src/app/helpers/product-pdf-files';
declare var $: any;


interface ProductTranslationField {
  value: string;
  manual: boolean;
}

interface ProductTranslationValue {
  productName: ProductTranslationField;
  description: ProductTranslationField;
  conditions: ProductTranslationField;
  productFiles: ProductFileTranslationValue[];
}

interface ProductTranslatePayload {
  en: ProductTranslationValue;
}

interface ProductFileTranslationValue {
  label: ProductTranslationField;
  url?: string;
  fileName?: string;
  s3Key?: string;
  sortOrder: number;
}

type ProductTranslationFieldName = 'productName' | 'description' | 'conditions';

interface ImageThumbnailVisual {
  id: number;
  url: string;
  previewUrl: string;
  previewFailed: boolean;
  state: 'processing' | 'ready' | 'error';
  overlay: boolean;
  text: boolean;
  error: string;
  slot: number;
  keepVisible: boolean;
  timers: number[];
}

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.scss']
})
export class EditProductComponent implements OnInit, OnDestroy {

  loading = true;
  productId: number = 0;
  product: any = {
    hidePrice: false
  };
  modules = {};

  productImages: any = [];
  productImagesToDelete: any = [];

  imageSizes: any = {
    thumbnail: 300,
    small: 400,
    medium: 600,
    main: undefined,
  };

  currency = "";
  sale = 0
  discountPercentage = 0;
  discountPrice = 0;
  firstSale=1;
  productPaymentMode = 1;
  // 1 = Pago Unico
  // 2 = Pago Recurrente

  pdfFileName: string | null | undefined;
  pdfFile: File | null = null;
  productFile: string = '';
  pdfSrc: string | null = null;
  productFiles: ProductPdfFile[] = [];
  productPdfFilesToDelete: string[] = [];
  pdfPreviewSafeUrl: any = null;
  pdfPreviewUrl: string | null = null;
  pdfPreviewTitle: string = '';
  timestamp: number;

  enabledSave = true;
  duplicatedVariants = false;
  emptyVariantValue = false;

  variantsOne: any = {
    variantType: '',
    variantValues: []
  };

  variantsTwo: any = {
    variantType: '',
    variantValues: []
  };

  variantsThree: any = {
    variantType: '',
    variantValues: []
  };

  taxSelected: any;
  taxActive: any;
  taxes: any[] = [];
  items: any = [];
  variants: any[] = [];
  deleteItems: any[] = [];
  categories: any;
  subCategories: any
  subSubCategories: any;
  industryTypes: any;
  suppliers: any[] = [];
  collections: any;
  variantValuesNames = <any[]>[];
  activeShopPoint = 0;
  shopPoints: any;
  productType: number = 1;
  originalImage: File | undefined;
  mainImage: string = '';
  mediumImage: string = '';
  smallImage: string = '';
  thumbnailImage: string = '';
  generalImages:any = []
  uploadingImages = false;
  deletingImages = false;
  savingImages = false;
  imageUploadProgress = { completed: 0, total: 0 };
  imageUploadError = '';
  private imageFilesToDelete: string[] = [];
  private imageKeyTimestamp = 0;
  private thumbnailVisuals: ImageThumbnailVisual[] = [];
  private thumbnailSequence = 0;

  get imageThumbnails(): ImageThumbnailVisual[] {
    const thumbnails = this.generalImages.map((image: any, slot: number) => {
      let thumbnail = this.thumbnailVisuals.find(entry => entry.url === image.url);
      if (!thumbnail) {
        thumbnail = this.createThumbnail(image.url, image.url, slot);
      }
      return thumbnail;
    });
    for (const thumbnail of this.thumbnailVisuals.filter(entry =>
      entry.keepVisible && !this.generalImages.some((image: any) => image.url === entry.url)
    ).sort((a, b) => a.slot - b.slot)) {
      thumbnails.splice(Math.min(thumbnail.slot, thumbnails.length), 0, thumbnail);
    }
    return thumbnails;
  }

  trackThumbnail(_index: number, thumbnail: ImageThumbnailVisual): number {
    return thumbnail.id;
  }

  private createThumbnail(url: string, previewUrl: string, slot: number): ImageThumbnailVisual {
    const thumbnail: ImageThumbnailVisual = {
      id: ++this.thumbnailSequence, url, previewUrl, previewFailed: false, slot,
      state: 'ready', overlay: false, text: false, error: '', keepVisible: false, timers: []
    };
    this.thumbnailVisuals.push(thumbnail);
    return thumbnail;
  }

  private processThumbnail(thumbnail: ImageThumbnailVisual): void {
    thumbnail.timers.forEach(timer => window.clearTimeout(timer));
    thumbnail.state = 'processing';
    thumbnail.error = '';
    thumbnail.overlay = false;
    thumbnail.text = false;
    thumbnail.timers = [
      window.setTimeout(() => { thumbnail.overlay = true; }, 140),
      window.setTimeout(() => { thumbnail.text = true; }, 700)
    ];
  }

  private finishThumbnail(thumbnail: ImageThumbnailVisual, error = ''): void {
    thumbnail.timers.forEach(timer => window.clearTimeout(timer));
    thumbnail.timers = [];
    thumbnail.state = error ? 'error' : 'ready';
    thumbnail.error = error;
    thumbnail.overlay = !!error;
    thumbnail.text = false;
    if (!error && thumbnail.previewFailed) this.onThumbnailImageError(thumbnail);
  }

  private setThumbnailPreview(thumbnail: ImageThumbnailVisual, previewUrl: string): void {
    const previousUrl = thumbnail.previewUrl;
    thumbnail.previewUrl = previewUrl;
    thumbnail.previewFailed = false;
    if (previousUrl.startsWith('blob:') && previousUrl !== previewUrl) {
      URL.revokeObjectURL(previousUrl);
    }
  }

  onThumbnailImageError(thumbnail: ImageThumbnailVisual): void {
    thumbnail.previewFailed = true;
    if (thumbnail.state !== 'ready' || !thumbnail.url ||
        (!thumbnail.previewUrl.startsWith('blob:') && !thumbnail.previewUrl.startsWith('data:'))) {
      return;
    }
    const separator = thumbnail.url.includes('?') ? '&' : '?';
    this.setThumbnailPreview(thumbnail, `${thumbnail.url}${separator}preview=${Date.now()}`);
  }

  async deleteImageThumbnail(thumbnail: ImageThumbnailVisual): Promise<void> {
    if (this.imagesBusy) return;
    if (!this.generalImages.some((image: any) => image.url === thumbnail.url)) {
      this.dismissThumbnail(thumbnail);
      return;
    }
    thumbnail.slot = this.imageThumbnails.indexOf(thumbnail);
    thumbnail.keepVisible = true;
    this.processThumbnail(thumbnail);
    await this.deleteProductImage(thumbnail.url);
    this.finishThumbnail(thumbnail, this.imageUploadError);
    if (!this.imageUploadError) this.dismissThumbnail(thumbnail);
  }

  private dismissThumbnail(thumbnail: ImageThumbnailVisual): void {
    thumbnail.timers.forEach(timer => window.clearTimeout(timer));
    if (thumbnail.previewUrl.startsWith('blob:')) URL.revokeObjectURL(thumbnail.previewUrl);
    this.thumbnailVisuals = this.thumbnailVisuals.filter(entry => entry !== thumbnail);
  }

  dropThumbnail(event: CdkDragDrop<string[]>): void {
    const thumbnails = this.imageThumbnails;
    const previousIndex = this.generalImages.findIndex((image: any) => image.url === thumbnails[event.previousIndex]?.url);
    const currentIndex = this.generalImages.findIndex((image: any) => image.url === thumbnails[event.currentIndex]?.url);
    // Transient previews do not occupy a position in the persisted image list.
    if (previousIndex >= 0 && currentIndex >= 0) {
      this.drop({ ...event, previousIndex, currentIndex });
    }
  }

  ngOnDestroy(): void {
    this.thumbnailVisuals.slice().forEach(thumbnail => this.dismissThumbnail(thumbnail));
  }

  get imagesBusy(): boolean {
    return this.uploadingImages || this.deletingImages || this.savingImages;
  }
  selectedImage: string = '';
  selectedItem: number = 0;
  checkIcon: string = '';
  itemRelationships: { [key: string]: string[] } = {};
  externalUrlTouched = false;
  externalUrlError = false;
  relationshipOptions: string[] = [
    "Titular","Conyuge", "Unión Libre", "Padre", "Madre", "Hijo", "Hija",
     "Suegro", "Suegra", "Gato", "Perro", "Otro"
   ];

  noItemImage = 'https://storetest.mobydyg.com/assets/Static/missing-image.png'

  total: number = 0;
  totalPages: number = 0;
  hasPrev: boolean = false;
  hasNext: boolean = false;

  selectedSuppliers: string[] = [];
  catalog: any[]      = [];
  productPackageItems: number[] = [];
  selected: any[] = [];
  filterLoading: boolean = false;
  subSubCategoriesForFilters: any;
  subCategoriesForFilters: any;
  filtersUsed = false;
  selectedLanguage: 'es' | 'en' = 'es';
  hasExistingEnglishTranslation = false;
  englishTranslation: ProductTranslationValue = this.buildFallbackEnglishTranslation();
  initialEnglishTranslation: ProductTranslationValue = this.buildFallbackEnglishTranslation();
  persistedEnglishFieldAvailability: Record<'productName' | 'description' | 'conditions', boolean> = {
    productName: false,
    description: false,
    conditions: false,
  };
  englishFieldEdited: Record<'productName' | 'description' | 'conditions', boolean> = {
    productName: false,
    description: false,
    conditions: false,
  };
  filters = {
    shopId:           this.themingService.shopId,
    counter:          0,
    amount:           10,
    search:           '',
    onlyActive:       1,
    categoryId:       0,
    subCategoryId:    0,
    subSubCategoryId: 0,
    collectionId:     0,
    supplierId:       0
  };

  periodOptions = [
    { labelKey: 'RENEWAL_PERIOD_1_MONTH', value: '30' },
    { labelKey: 'RENEWAL_PERIOD_2_MONTHS', value: '60' },
    { labelKey: 'RENEWAL_PERIOD_3_MONTHS', value: '90' },
    { labelKey: 'RENEWAL_PERIOD_4_MONTHS', value: '120' },
    { labelKey: 'RENEWAL_PERIOD_6_MONTHS', value: '180' },
    { labelKey: 'RENEWAL_PERIOD_1_YEAR',  value: '365' }
  ];

  selectedOption: string = 'custom';
  customDays: number = 0;

  public shopTheme: ShopTheming[] = [];
  constructor(
    public appComponent: AppComponent,
    public route: ActivatedRoute,
    public router: Router,
    public apiService: ApiService,
    public themingService: ThemingService,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    public el: ElementRef,
    private lambdaService: LambdaService
  ) {
    this.modules = {
      'emoji-shortname': true,
      'emoji-textarea': true,
      'emoji-toolbar': true,
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        //['blockquote', 'code-block'],
        [{ header: 1 }, { header: 2 }], // custom button values
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ direction: 'rtl' }], // text direction

        [
          {
            size: ['small', false, 'large', 'huge'],
            // size: [
            //   '8px',
            //   '10px',
            //   '12px',
            //   '14px',
            //   '16px',
            //   '18px',
            //   '20px',
            //   '22px',
            //   '24px',
            // ],
          },
        ], // custom dropdown

        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        [{ font: [] }],
        [{ align: [] }],

        //['link', 'image', 'video'], // link and image, video
        ['link'],
        ['emoji'],
      ],
    };

    this.route.paramMap.subscribe((params) => {
      let productId = Number(params.get('productId'));
      if (productId != this.productId) {
        this.appComponent.goToTop();
        this.productId = productId;
      }
    });
    this.timestamp = Date.now();
    this.shopTheme = this.themingService.shopTheming;
   }

   async ngOnInit(): Promise<void> {
    this.shopPoints = this.themingService.shopTheming[0].shopsLocation;
    await this.loadProduct().then(async () => {
      this.productFiles = this.normalizeProductFiles(this.product);
      this.productPdfFilesToDelete = [];
      await this.getTaxes();
      await this.getCategory();
      await this.getSubCategoryByCategoryId(this.product.product.productCategoryId);
      await this.getSubSubCategoryByCategoryId(this.product.product.productSubCategoryId);
      await this.getSuppliers();
      await this.getCollections();
      await this.getIndustry();
      await this.getSubSubCategoriesForFilters();
      await this.getSubCategoriesForFilters();
    //  await this.getFilteredProducts();
    });
    this.checkIcon = feather.icons.check.toSvg();

  }

  get canUseExternalRedirect(): boolean {
    return this.themingService.shopId === 4 || this.themingService.shopId === 14;
  }

  async getFilteredProducts(): Promise<void> {
    this.filterLoading = true; // mostrar spinner
    try {
      const resp: any = await this.lambdaService.getFilteredProducts(this.filters);
      this.catalog = resp.items ?? [];
      this.total = resp.total ?? 0;
      this.totalPages = resp.totalPages ?? 0;
      this.hasPrev = resp.hasPrev ?? false;
      this.hasNext = resp.hasNext ?? false;
    } catch (err) {
      console.error('Error cargando productos', err);
      this.catalog = [];
      this.total = 0;
      this.totalPages = 0;
    } finally {
      this.filterLoading = false; // ocultar spinner
    }
  }

  get pages(): (number | string)[] {
    const total = this.totalPages;
    const current = this.filters.counter + 1; // 1-based para mostrar
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);

    const out: (number | string)[] = [];
    const push = (x: number | string) => out.push(x);

    push(1);
    if (current > 4) push('…');

    const start = Math.max(2, current - 1);
    const end = Math.min(total - 1, current + 1);

    for (let p = start; p <= end; p++) push(p);

    if (current < total - 3) push('…');
    push(total);

    return out;
  }

  goToPage(p: string | number) {
    if (typeof p !== 'number') return; // ignorar si no es número
    if (p < 1 || p > this.totalPages) return;
    this.filters.counter = p - 1;
    this.getFilteredProducts();
  }

  nextPage() {
    if (this.hasNext) {
      this.filters.counter++;
      this.getFilteredProducts();
    }
  }

  prevPage() {
    if (this.hasPrev) {
      this.filters.counter--;
      this.getFilteredProducts();
    }
  }

  changePageSize() {
    this.filters.counter = 0;
    this.getFilteredProducts();
  }

  onSearchChange(txt: string) {
    this.filters.search = txt;
    this.filters.counter = 0;
    this.filtersUsed = false; // hay cambios sin aplicar
  }

  onCategoryChange(catId: number) {
    this.filters.categoryId = +catId;
    this.filters.counter = 0;
    this.filtersUsed = false;
  }

  onCollectionChange(colId: number) {
    this.filters.collectionId = +colId;
    this.filters.counter = 0;
    this.filtersUsed = false;
  }

  onSubCategoryChange(subCatId: number) {
    this.filters.subCategoryId = +subCatId;
    this.filters.counter = 0;
    this.filtersUsed = false;
  }

  onSubSubCategoryChange(subSubCatId: number) {
    this.filters.subSubCategoryId = +subSubCatId;
    this.filters.counter = 0;
    this.filtersUsed = false;
  }

  onSupplierChange(supId: number) {
    this.filters.supplierId = +supId;
    this.filters.counter = 0;
    this.filtersUsed = false;
  }

  toggleOnlyActive(checked: boolean) {
    this.filters.onlyActive = checked ? 1 : 0;
    this.filters.counter = 0;
    this.filtersUsed = false;
  }

  showProducts() {
    this.filters.counter = 0;
    this.filtersUsed = true;
    this.getFilteredProducts();
  }

  resetFilters() {
    this.filters = {
      shopId:           this.themingService.shopId,
      counter:          0,
      amount:           this.filters.amount,
      search:           '',
      onlyActive:       1,
      categoryId:       0,
      subCategoryId:    0,
      subSubCategoryId: 0,
      collectionId:     0,
      supplierId:       0
    };
    this.filtersUsed = false;
    this.getFilteredProducts();
  }

  toggleProduct(p: any) {
    const idx = this.selected.findIndex(x => x.productId === p.productId);
    if (idx === -1) {
      this.selected.push(p);
    } else {
      this.selected.splice(idx, 1);
    }
    this.productPackageItems = this.selected.map(x => x.productId);
  }

  isSelected(id: number) {
    return this.selected.some(x => x.productId === id);
  }

  async getSubSubCategoriesForFilters(): Promise<void> {
    try {
      const response: any = await this.lambdaService.getSubSubCategories(this.themingService.shopId);
      const subSubCategoryRows = Array.isArray(response.subSubCategories) ? response.subSubCategories : [];
      this.subSubCategoriesForFilters = subSubCategoryRows;
    } catch (error) {
      console.error('Error fetching subSubCategories:', error);
    }
  }

  async getSubCategoriesForFilters(): Promise<void> {
    try {
      const response: any = await this.lambdaService.getSubCategories(this.themingService.shopId);
      const subCategoryRows = Array.isArray(response.subCategories) ? response.subCategories : [];
      this.subCategoriesForFilters = subCategoryRows;
    } catch (error) {
      console.error('Error fetching subCategories:', error);
    }
  }

  selectImage(isSingleImage: number, input: HTMLInputElement){
    if (this.imagesBusy) return;
    if(isSingleImage === 0){
      this.selectedItem = 0
    }
    input.click();
  }

  async onFileSelected(event: any): Promise<void> {
    if (this.imagesBusy) return;
    const files: File[] = Array.from(event.target.files || []);
    if (!files.length) return;
    const firstSlot = this.imageThumbnails.length;
    const thumbnails = files.map((file, index) => {
      const thumbnail = this.createThumbnail('', URL.createObjectURL(file), firstSlot + index);
      thumbnail.keepVisible = true;
      this.processThumbnail(thumbnail);
      return thumbnail;
    });
    const selectedItem = this.selectedItem;
    this.uploadingImages = true;
    this.imageUploadError = '';
    this.imageUploadProgress = { completed: 0, total: files.length };
    try {
      for (const file of files) {
        const thumbnailVisual = thumbnails[this.imageUploadProgress.completed];
        this.originalImage = file;

        await new Promise<void>((resolve, reject) => {
          const reader = new FileReader();

          reader.onerror = () => reject(reader.error);
          reader.onload = (e: any) => {
            const image = new Image();
            image.onerror = () => reject(new Error('Unable to load selected image'));

            image.onload = async () => {
              try {
                // Redimensionar la imagen al tamaño máximo deseado
                const main = this.resizeImage(image, 800, 800);
                const medium = this.resizeImage(image, 600, 600);
                const small = this.resizeImage(image, 400, 400);
                const thumbnail = this.resizeImage(image, 300, 300);

                let timestamp = Date.now().toString()
                const mainFile = this.convertCanvasToFile(main, `${timestamp}-main.png`);
                const mediumFile = this.convertCanvasToFile(medium, `${timestamp}-medium.png`);
                const smallFile = this.convertCanvasToFile(small, `${timestamp}-small.png`);
                const thumbnailFile = this.convertCanvasToFile(thumbnail, `${timestamp}-thumbnail.png`);

                // Convertir las imágenes redimensionadas a cadenas base64
                this.mainImage = this.convertImageToBase64(main);
                this.mediumImage = this.convertImageToBase64(medium);
                this.smallImage = this.convertImageToBase64(small);
                this.thumbnailImage = this.convertImageToBase64(thumbnail);
                this.setThumbnailPreview(thumbnailVisual, this.smallImage);

                const images = await this.uploadS3Images(mainFile, mediumFile, smallFile, thumbnailFile);

                for (const item of images) {
                  if(item.imageType === 'small'){
                    thumbnailVisual.url = item.imageURL;
                    thumbnailVisual.keepVisible = false;
                    this.generalImages.push({
                      items: [],
                      isGeneral: 1,
                      url: item.imageURL
                    })
                  }
                }

                if(selectedItem !== 0){
                  const newImage = images.find((item:any) => item.imageURL.includes('small')).imageURL
                  if(newImage){
                    this.selectedImage = newImage;
                  }
                }

                this.finishThumbnail(thumbnailVisual);
                resolve();
              } catch (error) {
                reject(error);
              }
            };
            image.src = e.target.result;
          };

          // Leer el contenido del archivo como una URL de datos
          reader.readAsDataURL(file);
        }).catch(error => {
          this.imageUploadError = 'Una imagen no pudo completar sus cuatro variantes. Las imágenes completas se conservaron.';
          this.finishThumbnail(thumbnailVisual, this.imageUploadError);
          console.error('Image upload failed:', error);
        });
        this.imageUploadProgress.completed++;
      }
    } finally {
      event.target.value = '';
      this.uploadingImages = false;
    }
  }

  async deleteProductImage(image: string){
    if (this.imagesBusy) return;
    this.deletingImages = true;
    this.imageUploadError = '';
    try {
      const variants = this.getItemImages(image.split('?')[0].replace('-small.', '-size.'), 1, 1);
      const response: any = await this.lambdaService.deleteItemImages(
        variants.map(variant => ({ imageURL: variant.imageURL }))
      );
      if (response?.statusCode < 200 || response?.statusCode >= 300 || response?.success === false) {
        throw new Error('Image association deletion failed');
      }
      this.generalImages = this.generalImages.filter((item: any) => item.url !== image);
      if (this.selectedImage === image) this.selectedImage = '';
      this.imageFilesToDelete.push(...variants.map(variant =>
        variant.imageURL.replace('https://mobydyg-files.s3.amazonaws.com/', '')
      ));
      await this.deleteQueuedImageFiles();
    } catch (error) {
      this.imageUploadError = 'No se pudo eliminar la asociación de la imagen. No se eliminaron sus archivos.';
      console.error('Image deletion failed:', error);
    } finally {
      this.deletingImages = false;
    }
  }

  private async deleteQueuedImageFiles(): Promise<void> {
    const keys = Array.from(new Set(this.imageFilesToDelete));
    const failed: string[] = [];
    await Promise.all(keys.map(async key => {
      try {
        await this.lambdaService.deleteFile(key);
      } catch (error) {
        failed.push(key);
        console.error('Image file cleanup failed:', error);
      }
    }));
    this.imageFilesToDelete = failed;
    if (failed.length) {
      this.imageUploadError = 'La limpieza de archivos en S3 quedó incompleta. Se reintentará al guardar.';
    } else if (keys.length && this.imageUploadError.includes('S3')) {
      this.imageUploadError = '';
    }
  }

  private async uploadS3Images(mainFile: File, mediumFile: File, smallFile: File, thumbnailFile: File): Promise<any[]>{
    const mainExt = getFileExtension(mainFile);
    const mediumExt = getFileExtension(mediumFile);
    const smallExt = getFileExtension(smallFile);
    const thumbnailExt = getFileExtension(thumbnailFile);
    const timestamp = Math.max(Date.now(), this.imageKeyTimestamp + 1);
    this.imageKeyTimestamp = timestamp;

    const data = [
      {
        url: `${this.themingService.shopId}/${environment.stage}/images/item-images/${timestamp}-main.${mainExt}`,
        file: mainFile,
        options: {position: 1, type: 'main'}
      },
      {
        url: `${this.themingService.shopId}/${environment.stage}/images/item-images/${timestamp}-medium.${mediumExt}`,
        file: mediumFile,
        options: {position: 1, type: 'medium'}
      },
      {
        url: `${this.themingService.shopId}/${environment.stage}/images/item-images/${timestamp}-small.${smallExt}`,
        file: smallFile,
        options: {position: 1, type: 'small'}
      },
      {
        url: `${this.themingService.shopId}/${environment.stage}/images/item-images/${timestamp}-thumbnail.${thumbnailExt}`,
        file: thumbnailFile,
        options: {position: 1, type: 'thumbnail'}
      }
    ];

    const imagePromises = []

    for (const item of data) {
      item.options.position = Number(this.generalImages.length) + 1
      imagePromises.push(this.lambdaService.uploadFile(
        item.url,
        item.file,
        item.options
      ))
    }

    // Wait for every variant, including those still uploading after another fails.
    const results = await Promise.all(imagePromises.map((promise, index) =>
      promise.then(() => ({ index, success: true }), () => ({ index, success: false }))
    ));
    if (results.some(result => !result.success)) {
      this.imageFilesToDelete.push(...results.filter(result => result.success).map(result => data[result.index].url));
      throw new Error('Incomplete image variants');
    }

    const result = data.map(item => {
      return {
        imageURL: `https://mobydyg-files.s3.amazonaws.com/${item.url}`,
        position: item.options.position,
        imageType: item.options.type,
        isGeneral: 1
      }
    })
    return result;
  }

  private resizeImage(image: HTMLImageElement, maxWidth: number, maxHeight: number): HTMLCanvasElement {
    const canvas = document.createElement('canvas');
    let width = image.width;
    let height = image.height;

    // Redimensionar la imagen mientras se mantenga la proporción de aspecto
    if (width > height) {
      if (width > maxWidth) {
        height *= maxWidth / width;
        width = maxWidth;
      }
    } else {
      if (height > maxHeight) {
        width *= maxHeight / height;
        height = maxHeight;
      }
    }

    canvas.width = width;
    canvas.height = height;

    // Dibujar la imagen redimensionada en el lienzo
    const context = canvas.getContext('2d');
    context?.drawImage(image, 0, 0, width, height);

    return canvas;
  }

  private convertImageToBase64(image: HTMLCanvasElement): string {
    return image.toDataURL('image/jpeg');
  }

  convertCanvasToFile(canvas: HTMLCanvasElement, fileName: string): File {
    const dataURL = canvas.toDataURL('image/jpeg');
    const base64Data = dataURL.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: 'image/jpeg' });
    return new File([blob], fileName);
  }

  openSelectImageMoldal(itemId: number){
    if (this.imagesBusy) return;
    this.selectedImage = ''
    this.selectedItem = itemId
    const selectedItemImage = this.generalImages.find((item:any) => item.items.includes(itemId))
    if(selectedItemImage){
      this.selectedImage = selectedItemImage.url
    }
    $('#selectImagesModal').modal({ backdrop: 'static', keyboard: false });
    $('#selectImagesModal').modal('show');
    const input = document.querySelector('#item-image') as HTMLInputElement;
    const inputImage = document.querySelector('#image') as HTMLInputElement;
    if(input){
      input.value = itemId.toString()
    }
    if(inputImage){
      inputImage.value = this.selectedImage
    }
  }

  asociateImage(image: string){
    if (this.imagesBusy) return;
    if(this.selectedImage !== image){
      this.selectedImage = image
    }else{
      this.selectedImage = ''
    }
    const input = document.querySelector('#image') as HTMLInputElement;
    if(input){
      input.value = image
    }
  }

  confirmImage(){
    if (this.imagesBusy) return;
    if (!this.selectedImage &&
        this.generalImages.some((image: any) => image.items.includes(this.selectedItem)) &&
        !this.generalImages.some((image: any) => image.isGeneral === 1)) {
      this.imageUploadError = 'No hay imágenes generales disponibles. Agrega una imagen general o elimina la imagen específica.';
      return;
    }

    this.generalImages = this.generalImages.map((item: any) => {
      item.items = item.items.filter((item:any) => item !== this.selectedItem)
      if(item.url === this.selectedImage && this.selectedImage !== ''){
        item.items.push(this.selectedItem)
      }
      return item
    })

    $('#selectImagesModal').modal('hide');
  }

  getItemImages(image: string, isGeneral: number, position: number){
    const sizes = ['small', 'medium', 'thumbnail', 'main'];
    const itemImages = []
    for (const item of sizes) {
      const imageURLs =
      {
        imageURL: image.replace('size', item),
        position,
        imageType: item,
        isGeneral
      }
      itemImages.push(imageURLs)
    }
    return itemImages
  }

  getImageByItem(itemId: number): string{
    const imageURL = this.generalImages.find((item:any) => item.items.includes(itemId));
    if(!imageURL){
      return this.noItemImage;
    }
    return imageURL.url;
  }

  async loadProduct() {
    this.loading = true;
    if(this.themingService.shopTheming[0].currencyCode != "CRC"){
      this.currency = "$";
    }else{
      this.currency = "₡";
    }
    await this.lambdaService
      .getProductById(this.productId, this.themingService.shopId)
      .then((data) => {
        this.product = data;
        console.log('Product suppliers data loaded:', this.product.product.productSupplierId);
        // selectedSuppliers is an array. Need to insert each this.product.product.productSupplierId into selectedSuppliers array as numbers
        // this.selectedSuppliers = this.product.product.productSupplierId.split(',').map((id: string) => parseInt(id.trim()));
        //SPLIT ONLY IF NOT NULL OR EMPTY
        if (this.product.product.productSupplierId) {
          this.selectedSuppliers = this.product.product.productSupplierId.split(',').map((id: string) => id.trim());
        }
        if(!this.product.product.productContributionType){
          this.product.product.productContributionType = 'FIXED_AMOUNT'
          this.product.product.productContributionCurrency = 'CRC'
        }
        console.log('Selected suppliers:', this.selectedSuppliers);
        this.productFiles = this.normalizeProductFiles(this.product);
        this.productPdfFilesToDelete = [];
        this.productType = this.product.product.productType;
        this.initRenewalPeriod(this.product.product.productSessionRenewalPeriod);
        const loadedExternalUrl =
          this.product.product.externalUrl ||
          (<any>this.product.product).external_url ||
          null;
        const normalizedExternalUrl = loadedExternalUrl
          ? loadedExternalUrl.trim()
          : null;
        this.product.product.externalUrl = normalizedExternalUrl;
        this.product.product.externalRedirectEnabled =
          !!this.product.product.externalRedirectEnabled &&
          this.isValidExternalUrl(normalizedExternalUrl);
        this.externalUrlTouched = false;
        this.externalUrlError = false;
        this.initializeProductTranslation(
          this.product.product.productTranslate ?? this.product.productTranslate ?? null
        );
        if (Array.isArray(this.product.packageProducts)) {
          this.productPackageItems = this.product.packageProducts.map((p: { productId: any; }) => p.productId);
          this.selected = [...this.product.packageProducts];
        }

        //this.product.product.productDescription = decodeURI(this.product.product.productDescription);
        this.productImages = (<any>data).items[0].images || {};
        for (const key of Object.keys(this.productImages)) {
          this.productImages[key] = this.productImages[key] || [];
          for (let i = 0; i < this.productImages[key].length; i++) {
            this.productImages[key][i].imageURL =
              this.appComponent.randomCacheID(
                this.productImages[key][i].imageURL
              );
          }
        }




        const dataItems = (<any>data).items
        this.loadImageAssociations(dataItems);

        this.product.product.productBaseCost = this.product.product.productBaseCost;
        this.product.product.productSellPrice = this.product.product.productSellPrice;

        // Initialize hidePrice with default value if not present from backend
        if (this.product.product.hidePrice === undefined || this.product.product.hidePrice === null) {
          this.product.product.hidePrice = false;
        }

        this.product.variants[0] != undefined ? this.variantsOne = {
          ...this.product.variants[0]
        } : this.variantsOne = {
          variantType: '',
          variantValues: []
        };

        this.product.variants[1] != undefined ? this.variantsTwo = {
          ...this.product.variants[1]
        } : this.variantsTwo = {
          variantType: '',
          variantValues: []
        };

        this.product.variants[2] != undefined ? this.variantsThree = {
          ...this.product.variants[2]
        } : this.variantsThree = {
          variantType: '',
          variantValues: []
        };

        this.variants = this.product.variants;

        this.items = this.product.items.map((item: any) => {
          let itemShopPoints: any[] = [];
          let totalStock = 0;
          // this.product.shopPoints.forEach((shopPoint: any) => {
          //   totalStock += shopPoint.itemQuantity;
          //   itemShopPoints.push(
          //     {
          //       shopPointId: shopPoint.shopPointId,
          //       itemQuantity: shopPoint.itemQuantity
          //     }
          //   )
          // });


          let isAnyUnlimited = false;
          this.shopPoints.forEach((shopPoint: any) => {
            let arrayIndex = this.product.shopPoints.findIndex((sp: any) => sp.itemId == item.itemId && sp.shopPointId == shopPoint.shopPointId);
            if(arrayIndex >= 0){
              // console.log(`index del item ${item.itemId} con shoppoint ${shopPoint.shopPointId} es ${arrayIndex}`);
              //const itemShopPoint = item.itemShopPoints[arrayIndex]
              let itemShopPoint = this.product.shopPoints[arrayIndex];
              itemShopPoints.push(
                {
                  shopPointId: shopPoint.shopPointId,
                  itemQuantity: itemShopPoint.itemQuantity,
                  itemUnlimited: itemShopPoint.itemUnlimited
                }
              )
              if(itemShopPoint.itemUnlimited == 1){
                isAnyUnlimited = true;
              }
              totalStock += itemShopPoint.itemQuantity;
            }else{
              itemShopPoints.push(
                {
                  shopPointId: shopPoint.shopPointId,
                  itemQuantity: 0,
                  itemUnlimited: 0
                }
              )
            }
          });
          return {
            itemId: item.itemId,
            itemActive: item.itemActive,
            itemCode: item.itemCode,
            //itemVariantCode: item.itemCode.substring(item.itemCode.length - 2 ,item.itemCode.length),
            //itemBaseCode: item.itemCode.substring(0 ,item.itemCode.length - 2),
            itemPrice: item.itemPrice.toFixed(2),
            itemDiscountPrice: item.itemDiscountPrice,
            itemQuantity: item.quantity,
            itemSessions: item.itemSessions,
            itemBeneficiaries: item.itemBeneficiaries,
            itemHolder: item.itemHolderRequired,
            variantValues: item.variantValues,
            itemShopPoints: itemShopPoints,
            itemTotalStock: isAnyUnlimited? 'Ilimitado' : totalStock,
            itemRelationship: item.itemRelationship ? item.itemRelationship.split(',') : []
          };
        });


        for (let item of this.items) {
          let variantValueNames: any = [];
          if(item.variantValues){
            for (let variantValue of item.variantValues) {
              variantValueNames.push({variantValueName: variantValue})
            }
          }
          item.variantValues = variantValueNames;
        }

      }).then(() => {
        this.discountPercentage = this.calculateDiscountPercentage();
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.loading = false;
        setTimeout(() => {
          feather.replace();
        }, 100);
      });
  }

  private buildFallbackEnglishTranslation(): ProductTranslationValue {
    return {
      productName: { value: this.product?.product?.productName || '', manual: false },
      description: { value: this.product?.product?.productDescription || '', manual: false },
      conditions: { value: this.product?.product?.productConditions || '', manual: false },
      productFiles: this.buildFallbackProductFilesTranslation(),
    };
  }

  private buildFallbackProductFilesTranslation(): ProductFileTranslationValue[] {
    return this.productFiles.map((pdf, index) => ({
      label: { value: pdf.label || '', manual: false },
      url: pdf.url,
      fileName: pdf.fileName,
      s3Key: pdf.s3Key,
      sortOrder: index + 1,
    }));
  }

  private parseProductTranslate(rawProductTranslate: unknown): ProductTranslatePayload | null {
    if (!rawProductTranslate) {
      return null;
    }
    if (typeof rawProductTranslate === 'string') {
      try {
        return JSON.parse(rawProductTranslate);
      } catch (error) {
        console.error('Invalid productTranslate JSON payload:', error);
        return null;
      }
    }
    return typeof rawProductTranslate === 'object' ? rawProductTranslate as ProductTranslatePayload : null;
  }

  private hasMeaningfulTranslation(value: ProductTranslationValue): boolean {
    return [
      value.productName.value,
      value.description.value,
      value.conditions.value,
      ...value.productFiles.map((file) => file.label.value),
    ].some((field) => this.hasMeaningfulText(field));
  }

  private hasMeaningfulText(value: string | null | undefined): boolean {
    if (value == null) {
      return false;
    }

    const normalized = String(value)
      .replace(/<[^>]*>/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    return normalized.length > 0;
  }

  private initializeProductTranslation(rawProductTranslate: unknown): void {
    const fallback = this.buildFallbackEnglishTranslation();
    const parsed = this.parseProductTranslate(rawProductTranslate);
    const rawEnglish: any = parsed?.en;

    if (!rawEnglish || typeof rawEnglish !== 'object') {
      this.englishTranslation = { ...fallback };
      this.initialEnglishTranslation = { ...fallback };
      this.hasExistingEnglishTranslation = false;
      this.persistedEnglishFieldAvailability = {
        productName: false,
        description: false,
        conditions: false,
      };
      this.englishFieldEdited = {
        productName: false,
        description: false,
        conditions: false,
      };
      return;
    }

    const persistedGlobalManual = rawEnglish.manual === true;

    const wrapField = (field: any, fallbackValue: string): ProductTranslationField => {
      if (typeof field === 'object' && field !== null && 'value' in field) {
        return {
          value: field.value ?? fallbackValue,
          manual: field.manual === true,
        };
      }

      return {
        value: field ?? fallbackValue,
        manual: persistedGlobalManual,
      };
    };

    const translatedProductFiles = Array.isArray(rawEnglish.productFiles)
      ? rawEnglish.productFiles
      : [];

    const normalized: ProductTranslationValue = {
      productName: wrapField(rawEnglish.productName, fallback.productName.value),
      description: wrapField(rawEnglish.description, fallback.description.value),
      conditions: wrapField(rawEnglish.conditions, fallback.conditions.value),
      productFiles: this.productFiles.map((pdf, index) => {
        const translatedFile = this.findTranslatedProductFile(translatedProductFiles, pdf, index);
        const label = wrapField(translatedFile?.label, pdf.label || '');
        pdf.translatedLabel = this.hasMeaningfulText(label.value) ? label.value : undefined;

        return {
          label,
          url: pdf.url,
          fileName: pdf.fileName,
          s3Key: pdf.s3Key,
          sortOrder: index + 1,
        };
      }),
    };

    this.englishTranslation = { ...normalized };
    this.initialEnglishTranslation = { ...normalized };
    this.hasExistingEnglishTranslation = this.hasMeaningfulTranslation(normalized);
    this.persistedEnglishFieldAvailability = {
      productName: this.hasMeaningfulText(normalized.productName.value),
      description: this.hasMeaningfulText(normalized.description.value),
      conditions: this.hasMeaningfulText(normalized.conditions.value),
    };
    this.englishFieldEdited = {
      productName: false,
      description: false,
      conditions: false,
    };
  }

  private syncEnglishTranslationFallback(descriptionHtml?: string, conditionsHtml?: string): void {
    const fallback = this.buildFallbackEnglishTranslation();
    const keepAutomaticField = (field: 'productName' | 'description' | 'conditions'): boolean =>
      this.persistedEnglishFieldAvailability[field] === true && this.englishTranslation[field].manual !== true;

    this.englishTranslation = {
      ...this.englishTranslation,
      productName: this.shouldKeepManualValue('productName')
        ? { ...this.englishTranslation.productName }
        : keepAutomaticField('productName')
          ? { ...this.englishTranslation.productName }
        : { ...fallback.productName },
      description: this.shouldKeepManualValue('description')
        ? { ...this.englishTranslation.description }
        : keepAutomaticField('description')
          ? { ...this.englishTranslation.description }
        : (descriptionHtml !== undefined
            ? { value: descriptionHtml || '', manual: false }
            : { ...fallback.description }),
      conditions: this.shouldKeepManualValue('conditions')
        ? { ...this.englishTranslation.conditions }
        : keepAutomaticField('conditions')
          ? { ...this.englishTranslation.conditions }
        : (conditionsHtml !== undefined
            ? { value: conditionsHtml || '', manual: false }
            : { ...fallback.conditions }),
      productFiles: this.syncProductFilesTranslationFallback(
        this.englishTranslation.productFiles,
        fallback.productFiles
      ),
    };

    this.initialEnglishTranslation = {
      ...this.initialEnglishTranslation,
      productName: this.initialEnglishTranslation.productName.manual
        ? { ...this.initialEnglishTranslation.productName }
        : this.persistedEnglishFieldAvailability.productName
          ? { ...this.initialEnglishTranslation.productName }
        : { ...fallback.productName },
      description: this.initialEnglishTranslation.description.manual
        ? { ...this.initialEnglishTranslation.description }
        : this.persistedEnglishFieldAvailability.description
          ? { ...this.initialEnglishTranslation.description }
        : (descriptionHtml !== undefined
            ? { value: descriptionHtml || '', manual: false }
            : { ...fallback.description }),
      conditions: this.initialEnglishTranslation.conditions.manual
        ? { ...this.initialEnglishTranslation.conditions }
        : this.persistedEnglishFieldAvailability.conditions
          ? { ...this.initialEnglishTranslation.conditions }
        : (conditionsHtml !== undefined
            ? { value: conditionsHtml || '', manual: false }
            : { ...fallback.conditions }),
      productFiles: this.syncProductFilesTranslationFallback(
        this.initialEnglishTranslation.productFiles,
        fallback.productFiles
      ),
    };
  }

  private buildProductTranslateField(field: ProductTranslationField): ProductTranslationField {
    const value = field.value || '';
    return {
      value,
      manual: false,
    };
  }

  private getAutomaticEnglishFieldValue(field: ProductTranslationFieldName): string {
    if (this.persistedEnglishFieldAvailability[field]) {
      return this.initialEnglishTranslation[field].value || '';
    }

    return this.buildFallbackEnglishTranslation()[field].value || '';
  }

  private shouldKeepManualValue(field: ProductTranslationFieldName): boolean {
    return this.englishTranslation[field].manual === true && this.englishFieldEdited[field] === true;
  }

  private resolveProductTranslatePayload(): ProductTranslatePayload {
    return {
      en: {
        productName: {
          value: this.englishTranslation.productName.value || '',
          manual: this.englishTranslation.productName.manual === true
            && this.englishFieldEdited.productName === true
            && this.hasMeaningfulText(this.englishTranslation.productName.value),
        },
        description: {
          value: this.englishTranslation.description.value || '',
          manual: this.englishTranslation.description.manual === true
            && this.englishFieldEdited.description === true
            && this.hasMeaningfulText(this.englishTranslation.description.value),
        },
        conditions: {
          value: this.englishTranslation.conditions.value || '',
          manual: this.englishTranslation.conditions.manual === true
            && this.englishFieldEdited.conditions === true
            && this.hasMeaningfulText(this.englishTranslation.conditions.value),
        },
        productFiles: this.productFiles
          .filter((pdf) => !pdf.markedForDelete)
          .map((pdf, index) => {
            const translatedFile = this.englishTranslation.productFiles[index];
            const label = translatedFile?.label || { value: pdf.translatedLabel || pdf.label || '', manual: false };

            return {
              label: {
                value: label.value || '',
                manual: label.manual === true && this.hasMeaningfulText(label.value),
              },
              url: pdf.url,
              fileName: pdf.fileName,
              s3Key: pdf.s3Key,
              sortOrder: index + 1,
            };
          }),
      },
    };
  }

  private findTranslatedProductFile(translatedFiles: any[], pdf: ProductPdfFile, index: number): any {
    return translatedFiles.find((file) => file?.s3Key && file.s3Key === pdf.s3Key)
      || translatedFiles.find((file) => file?.url && file.url === pdf.url)
      || translatedFiles[index]
      || null;
  }

  private syncProductFilesTranslationFallback(
    currentFiles: ProductFileTranslationValue[] = [],
    fallbackFiles: ProductFileTranslationValue[] = []
  ): ProductFileTranslationValue[] {
    return this.productFiles.map((pdf, index) => {
      const current = currentFiles[index];
      const fallback = fallbackFiles[index] || {
        label: { value: pdf.label || '', manual: false },
        sortOrder: index + 1,
      };
      const label = current?.label?.manual === true
        ? { ...current.label }
        : { ...fallback.label };

      pdf.translatedLabel = this.hasMeaningfulText(label.value) && label.value !== pdf.label
        ? label.value
        : undefined;

      return {
        label,
        url: pdf.url,
        fileName: pdf.fileName,
        s3Key: pdf.s3Key,
        sortOrder: index + 1,
      };
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    if (this.imagesBusy) return;
    moveItemInArray(this.generalImages, event.previousIndex, event.currentIndex);
  }

  // downloadImage(position: number) {
  //   fetch(this.productImages.main[position].imageURL)
  //     .then((response) => response.blob())
  //     .then((blob) => {
  //       let blobUrl = window.URL.createObjectURL(blob);
  //       let a = document.createElement('a');
  //       a.download =
  //         this.product.product.productCode + '-' + (position + 1) + '.png';
  //       a.href = blobUrl;
  //       document.body.appendChild(a);
  //       a.click();
  //       a.remove();
  //     });
  // }

  deletePhoto(i: number) {
    let image = this.productImages.small[i];
    for (const key of Object.keys(this.productImages)) {
      if (image.file == undefined) {
        this.productImagesToDelete.push(
          JSON.parse(JSON.stringify(this.productImages[key][i].imageURL))
        );
      }
      this.productImages[key].splice(i, 1);
    }
    //console.log(this.productImagesToDelete);
  }

  async uploadImage() {
    var inputFile = $(
      '<input type="file" id="fileInput" multiple="true" style="visibility: hidden; height: 0; width: 0; overflow: hidden" />'
    );
    let aux_this = this;
    inputFile.bind('change', (event: any) => {
      aux_this.readFile(event.target.files);
    });
    inputFile.trigger('click');
  }

  async readFile(files: any) {
    let aux_this = this;
    for (let i = 0; i < (<any>files).length; i++) {
      var promise = new Promise(async (resolve, reject) => {
        let timestamp = Date.now().toString() + '-' + (i + 1);
        var reader = new FileReader();
        reader.readAsDataURL((<any>files)[i]); // read file as data url
        reader.onload = async () => {
          // called once readAsDataURL is completed
          if (reader.result != null) {
            var blob = (<any>files)[i].slice(
              0,
              (<any>files)[i].size,
              'image/png'
            );
            let mainFile = new File([blob], timestamp + '-main', {
              type: 'image/png',
            });
            aux_this.productImages.main = aux_this.productImages.main || [];
            aux_this.productImages.main.push({
              imageURL: this.sanitizer.bypassSecurityTrustResourceUrl(
                <any>reader.result
              ),
              file: mainFile,
            });

            let promises = [];

            for (const key of Object.keys(aux_this.imageSizes)) {
              promises.push(
                new Promise((resolve2, reject2) => {
                  if (aux_this.imageSizes[key] != undefined) {
                    let img = new Image();
                    img.src = <string>reader.result;
                    var c = document.createElement('canvas');
                    var blob;

                    img.onload = async function () {
                      c.width = aux_this.imageSizes[key];
                      c.height = c.width;

                      let newWidth = img.width;
                      let newHeight = img.height;
                      if (img.width > img.height) {
                        if (img.width > c.width) {
                          newHeight *= c.width / newWidth;
                          c.height = newHeight;
                          newWidth = c.width;
                        }
                      } else {
                        if (img.height > c.height) {
                          newWidth *= c.height / newHeight;
                          c.width = newWidth;
                          newHeight = c.height;
                        }
                      }
                      var ctx = c.getContext('2d');
                      (<any>ctx).drawImage(img, 0, 0, newWidth, newHeight); // draw in image
                      c.toBlob(
                        async function (blob0) {
                          blob = blob0;
                          (<any>blob).name = timestamp + '-' + key;
                          (<any>blob).lastModified = new Date();
                          let file = <File>blob;
                          var reader2 = new FileReader();
                          reader2.readAsDataURL(file); // read file as data url
                          reader2.onload = () => {
                            aux_this.productImages[key] =
                              aux_this.productImages[key] || [];
                            aux_this.productImages[key].push({
                              imageURL:
                                aux_this.sanitizer.bypassSecurityTrustResourceUrl(
                                  <any>reader2.result
                                ),
                              file: file,
                            });
                            resolve2(0);
                          };
                        },
                        'image/png',
                        1
                      );
                    };
                  } else {
                    resolve2(0);
                  }
                })
              );
            }
            await Promise.all(promises);
            resolve(0);
          } else {
            reject();
          }
        };
      });
    }
  }

  throttleActions(listOfCallableActions: any[], limit: number) {
    // We'll need to store which is the next promise in the list.
    let i = 0;
    let resultArray = new Array(listOfCallableActions.length);

    // Now define what happens when any of the actions completes. Javascript is
    // (mostly) single-threaded, so only one completion handler will call at a
    // given time. Because we return doNextAction, the Promise chain continues as
    // long as there's an action left in the list.
    function doNextAction(): any {
      if (i < listOfCallableActions.length) {
        // Save the current value of i, so we can put the result in the right place
        let actionIndex = i++;
        let nextAction = listOfCallableActions[actionIndex];
        return Promise.resolve(nextAction())
          .then((result) => {
            // Save results to the correct array index.
            resultArray[actionIndex] = result;
            return;
          })
          .then(doNextAction);
      }
    }

    // Now start up the original <limit> number of promises.
    // i advances in calls to doNextAction.
    let listOfPromises = [];
    while (i < limit && i < listOfCallableActions.length) {
      listOfPromises.push(doNextAction());
    }
    return Promise.all(listOfPromises).then(() => resultArray);
  }

  async getTaxes() {
    if(this.product.product.productTaxId == 1){
      this.taxes = [{
        "taxId": 1,
        "taxCountryId": 1,
        "taxCode": "0",
        "taxName": "Regimen Simplificado",
        "taxValue": 0,
        "taxParent": null,
        "taxActive": "1"
    }];
    }else{
      await this.lambdaService
      .getTaxes(this.themingService.shopId)
      .then((data: any) => {
        const taxesArray = data?.taxes ?? [];

        let prodTax = taxesArray.find((tax: any) => tax.taxId == this.product.product.productTaxId);

        if (prodTax?.taxValue == 0) {
          this.taxActive = prodTax;
        } else {
          this.taxActive = taxesArray.find((tax: any) => tax.taxId == prodTax?.taxParent);
        }

        this.taxes = taxesArray.filter((tax: any) => tax.taxParent == this.taxActive?.taxId);

        if (this.taxes.length > 0) {
         this.taxes = this.taxes.sort((a, b) => a.taxValue - b.taxValue);
         this.taxSelected = this.taxes.find((taxValue: any) => taxValue.taxId == this.product.product.productTaxId);
         this.taxSelected.taxValue = parseFloat(this.taxSelected.taxValue);
        } else {
          this.taxes = this.taxActive;
          this.taxSelected = this.taxActive;
          this.taxSelected.taxValue = parseFloat(this.taxSelected.taxValue);
        }
      })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  getCategory() {
  this.lambdaService
    .getCategories(this.themingService.shopId)
    .then((data: any) => {
      if (Array.isArray(data)) {
        this.categories = data[0] || [];
      } else {
        this.categories = [];
        console.error('Formato de respuesta no esperado:', data);
      }
    })
    .catch((error) => {
      console.error('Error al obtener categorías:', error);
    })
    .finally(() => {
      $('#createProductModal').modal('hide');
    });
  }

  async getSubCategoryByCategoryId(categoryId: number) {
    await this.lambdaService
    .getSubCategoryByCategoryId( categoryId,this.themingService.shopId, )
    .then((data: any) => {
      this.subCategories = data.subCategories;
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
    });
  }

  async getSubSubCategoryByCategoryId(subCategoryId: number) {
    await this.lambdaService
      .getSubSubCategoryByCategoryId(subCategoryId, this.themingService.shopId)
      .then((data: any) => {
        this.subSubCategories = data.subSubCategories;
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
      });
  }

  async getIndustry() {
    await this.lambdaService
      .getIndustries()
      .then((data: any) => {
        this.industryTypes = data.industries;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async getSuppliers() {
    await this.lambdaService
      .getSuppliers(this.themingService.shopId)
      .then((data: any) => {
        this.suppliers = data.suppliers;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async getCollections() {
    await this.lambdaService
      .getCollections(this.themingService.shopId)
      .then((data: any) => {
        this.collections = data.collections;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  calculateDiscountPercentage(){
    let discountPercentage = 0;
    if(this.product.product.productDiscountPrice > 0){
      discountPercentage = 100 -((this.product.product.productDiscountPrice / this.product.product.productSellPrice) * 100);
    }
    //console.log(discountPercentage);
    return discountPercentage;
  }

  calculateFinalPrice(){
    let taxPercentage = parseFloat(this.taxSelected.taxValue)/100;
    if(this.product.product.gainMargin > 0){
      let sellprice = 0;
      sellprice = this.product.product.productBaseCost + (this.product.product.productBaseCost * (this.product.product.gainMargin / 100));
      this.product.product.productSellPrice = sellprice + (sellprice * taxPercentage);
    }else{
      this.product.product.productSellPrice = this.product.product.productBaseCost + (this.product.product.productBaseCost * taxPercentage);
    }
    if(this.items){
      const items = this.items.map((item : any) => {
        item.itemPrice = this.product.product.productSellPrice.toFixed(2);
        return item;
      });
      this.items = items;
    }
  }

  descriptionChanged(event: any) {
    //console.log(event);
    //console.log(encodeURI(event.html));

    // this.product.product.productDescription = event.innerHTML;
    if (event.event === 'text-change') {
      this.syncEnglishTranslationFallback(event.html, undefined);
    }
  }

  changeName(event: Event) {
    const element = event.target as HTMLInputElement;
    this.product.product.productName = element.value;
    this.syncEnglishTranslationFallback();
  }

  conditionsChanged(event: any) {
    if (event.event === 'text-change') {
      this.syncEnglishTranslationFallback(undefined, event.html);
    }
  }

  changeCategory(event: Event) {
    const element = event.target as HTMLSelectElement;
    this.product.product.productCategoryId = parseInt(element.value);
    this.getSubCategoryByCategoryId(this.product.product.productCategoryId);
  }

  changeSubCategory(event: Event) {
    const element = event.target as HTMLSelectElement;
    this.product.product.productSubCategoryId = parseInt(element.value);
    this.getSubSubCategoryByCategoryId(this.product.product.productSubCategoryId);
    this.resetSubSubcategories();
  }

  changeSubSubCategory(event: Event) {
    const element = event.target as HTMLSelectElement;
    this.product.product.productSubSubCategoryId = parseInt(element.value);
  }

  resetSubcategories() {
    this.product.product.productSubCategoryId = 0;
    this.product.product.productSubSubCategoryId = 0;
    this.subCategories = [];
    this.subSubCategories = [];
  }

  resetSubSubcategories() {
    this.product.product.productSubSubCategoryId = 0;
    this.subSubCategories = [];
  }

  changeIndustry(event: Event) {
    const element = event.target as HTMLSelectElement;
    this.product.product.productIndustryTypeId = parseInt(element.value);
  }

  changeSupplier(event: Event) {
    const element = event.target as HTMLSelectElement;
    this.product.product.productSupplierId = parseInt(element.value);
  }

  toggleSupplier(id: number, event: any) {
    if (event.target.checked) {
      this.selectedSuppliers.push(id.toString());
    } else {
      this.selectedSuppliers = this.selectedSuppliers.filter(x => x !== id.toString());
    }

    this.product.product.productSupplierId = this.selectedSuppliers.join(',');
    console.log("Selected supplier IDs:", this.product.product.productSupplierId);
  }

  get supplierButtonText(): string {
    if (this.selectedSuppliers.length === 0) {
      return 'Seleccionar proveedores';
    }
    console.log("Selected supplier IDs:", this.selectedSuppliers);
    console.log("Selected supplier IDs:", this.suppliers);
    const names = this.suppliers
      .filter((s: any) => this.selectedSuppliers.includes(s.supplierId.toString()))
      .map((s: any) => s.supplierName);

    if (names.length <= 2) {
      return names.join(', ');
    }

    return `${names.length} proveedores seleccionados`;
  }

  changeCollection(event: Event) {
    const element = event.target as HTMLSelectElement;
    this.product.product.productCollectionId = parseInt(element.value);
  }

  changeContribution(event: Event) {
    const element = event.target as HTMLInputElement;
    if(parseFloat(element.value) >= 0){
      this.product.product.productContribution = parseFloat(element.value);
    }else{
      this.product.product.productContribution = 0;
    }
    console.log(this.product.product.productContribution);
  }

  changeGracePeriod(event: Event) {
    const element = event.target as HTMLInputElement;
    if(parseInt(element.value) >= 0){
      this.product.product.productGracePeriod = parseInt(element.value);
    }else{
      this.product.product.productGracePeriod = 0;
    }
  }

  /** Eventos del Select */
  onSelectedOptionChange(): void {
  if (this.selectedOption !== 'custom') {
    this.product.product.productSessionRenewalPeriod = Number(this.selectedOption);
    this.customDays = 0;
  }
}

  /** Evento del Input numérico */
  onCustomRenewalPeriodInput(event: Event): void {
    const inputEl = event.target as HTMLInputElement;
    this.customDays = Number(inputEl.value) || 0;
    this.product.product.productSessionRenewalPeriod = this.customDays;
  }

  initRenewalPeriod(daysFromBackend: number | null | undefined): void {
    const days = Number(daysFromBackend) || 0;
    this.product.product.productSessionRenewalPeriod = days;

    // ¿Coincide con una opción predefinida?
    const matched = this.periodOptions.find(opt => Number(opt.value) === days);
    if (matched) {
      this.selectedOption = matched.value;
      this.customDays = 0; // Limpiamos el input custom
    } else {
      this.selectedOption = 'custom';
      this.customDays = days > 0 ? days : 0;
    }
  }

  changeRenewalPeriod(event: Event) {
    const element = event.target as HTMLInputElement;
    if(parseInt(element.value) >= 0){
      this.product.product.productSessionRenewalPeriod = parseInt(element.value);
    }else{
      this.product.product.productSessionRenewalPeriod = 0;
    }
  }

  selectLanguage(language: 'es' | 'en'): void {
    this.selectedLanguage = language;
  }

  onManualFieldToggle(field: ProductTranslationFieldName, event: Event): void {
    const enabled = (event.target as HTMLInputElement).checked;
    const currentField = this.englishTranslation[field];
    const automaticValue = this.getAutomaticEnglishFieldValue(field);

    if (enabled && !this.hasMeaningfulText(currentField.value)) {
      this.englishTranslation = {
        ...this.englishTranslation,
        [field]: {
          value: automaticValue,
          manual: true,
        },
      };
      this.englishFieldEdited[field] = false;
    } else {
      this.englishTranslation = {
        ...this.englishTranslation,
        [field]: {
          value: enabled ? currentField.value : automaticValue,
          manual: enabled,
        },
      };
      if (!enabled) {
        this.englishFieldEdited[field] = false;
      }
    }

    if (enabled) {
      this.selectedLanguage = 'en';
    }
  }

  updateEnglishField(field: ProductTranslationFieldName, value: string): void {
    this.englishTranslation = {
      ...this.englishTranslation,
      [field]: {
        ...this.englishTranslation[field],
        value: value || '',
      },
    };
    this.englishFieldEdited[field] = true;
  }

  isEnglishFieldReadonly(field: ProductTranslationFieldName): boolean {
    return this.englishTranslation[field].manual !== true;
  }

  hasEnglishFieldPreview(field: ProductTranslationFieldName): boolean {
    return this.hasMeaningfulText(this.englishTranslation[field].value);
  }

  isEnglishFieldManual(field: ProductTranslationFieldName): boolean {
    return this.englishTranslation[field].manual === true;
  }

  onPdfLabelChange(index: number, value: string): void {
    const pdf = this.productFiles[index];
    if (!pdf) {
      return;
    }

    pdf.label = value || '';
    const translatedFile = this.englishTranslation.productFiles[index];
    if (translatedFile && translatedFile.label.manual !== true) {
      translatedFile.label.value = pdf.label;
      pdf.translatedLabel = undefined;
    }
  }

  onManualPdfLabelToggle(index: number, event: Event): void {
    const enabled = (event.target as HTMLInputElement).checked;
    const pdf = this.productFiles[index];
    const translatedFile = this.ensureProductFileTranslation(index);
    const currentValue = translatedFile.label.value || pdf?.translatedLabel || '';
    const automaticValue = pdf?.translatedLabel || pdf?.label || '';

    translatedFile.label = {
      value: enabled ? (currentValue || automaticValue) : automaticValue,
      manual: enabled,
    };

    if (!enabled && pdf) {
      pdf.translatedLabel = undefined;
    }

    if (enabled) {
      this.selectedLanguage = 'en';
    }
  }

  updateEnglishPdfLabel(index: number, value: string): void {
    const translatedFile = this.ensureProductFileTranslation(index);
    translatedFile.label = {
      ...translatedFile.label,
      value: value || '',
      manual: true,
    };

    if (this.productFiles[index]) {
      this.productFiles[index].translatedLabel = value || undefined;
    }
  }

  isEnglishPdfLabelManual(index: number): boolean {
    return this.englishTranslation.productFiles[index]?.label?.manual === true;
  }

  isEnglishPdfLabelReadonly(index: number): boolean {
    return !this.isEnglishPdfLabelManual(index);
  }

  getEnglishPdfLabel(index: number): string {
    return this.englishTranslation.productFiles[index]?.label?.value || '';
  }

  hasEnglishPdfLabelPreview(index: number): boolean {
    return this.hasMeaningfulText(this.getEnglishPdfLabel(index));
  }

  isValidExternalUrl(url: string | null): boolean {
    if (!url) {
      return false;
    }
    return /^https?:\/\/.+/i.test(url.trim());
  }

  onExternalRedirectToggle(event: Event) {
    const element = event.target as HTMLInputElement;
    this.product.product.externalRedirectEnabled = element.checked;
    this.externalUrlTouched = element.checked ? true : false;
    if (!element.checked) {
      this.externalUrlTouched = false;
      this.externalUrlError = false;
    }
  }

  onExternalUrlChange(event: Event) {
    const element = event.target as HTMLInputElement;
    this.product.product.externalUrl = element.value;
    this.externalUrlTouched = true;
    this.externalUrlError = false;
  }

  isExternalRedirectActive(): boolean {
    const url = this.product?.product?.externalUrl
      ? this.product.product.externalUrl.trim()
      : '';
    return (
      this.product?.product?.externalRedirectEnabled === true &&
      !!url &&
      this.isValidExternalUrl(url)
    );
  }

  showExternalUrlInvalid(): boolean {
    if (!this.product?.product?.externalRedirectEnabled) {
      return false;
    }
    const url = this.product.product.externalUrl ? this.product.product.externalUrl.trim() : '';
    const missingOrInvalid = !url || !this.isValidExternalUrl(url);
    return missingOrInvalid && (this.externalUrlTouched || this.externalUrlError);
  }

  changeBaseCost(event: Event) {
    const element = event.target as HTMLInputElement;
    if (parseFloat(element.value) >= 0) {
      this.product.product.productBaseCost = parseFloat(element.value);
    } else {
      this.product.product.productBaseCost = 0;
    }
    this.calculateFinalPrice();
  }

  changeTax(event: Event) {
    const element = event.target as HTMLSelectElement;
    this.product.product.productTaxId = parseFloat(element.value);
    this.taxSelected = this.taxes.find((taxValue: any) => taxValue.taxId == parseFloat(element.value));
    this.calculateFinalPrice();
  }

  changeSellPrice(event: Event) {
    const element = event.target as HTMLInputElement;
    if (parseFloat(element.value) >= 0) {
      this.product.product.productSellPrice = parseFloat(element.value);
      if(this.items){
        const items = this.items.map((item : any) => {
          item.itemPrice = parseFloat(element.value).toFixed(2);
          return item;
        });
        this.items = items;
      }
    } else {
      this.product.product.productSellPrice = 0;
      if(this.items){
        const items = this.items.map((item : any) => {
          item.itemPrice = parseFloat(element.value).toFixed(2);
          return item;
        });
        this.items = items;
      }
    }
  }

  changeDiscountPrice(event: Event) {
    const element = event.target as HTMLInputElement;
    this.discountPrice = parseFloat(element.value);
  }

  onContributionTypeChange(): void {
    // Opcional: validar/transformar el monto según el nuevo tipo
    if (this.product.product.productContributionType === 'PERCENTAGE') {
      // Ejemplo: asegurar que el porcentaje esté entre 0-100
      const val = Number(this.product.product.productContribution);
      if (val > 100) this.product.product.productContribution = 100;
    }
  }

  changeGainMargin(event: Event) {
    const element = event.target as HTMLInputElement;

    if (parseFloat(element.value) > 0) {
      this.product.product.gainMargin = parseFloat(element.value);
      if(this.taxSelected){
        let sellprice = 0;
        sellprice = this.product.product.productBaseCost + (this.product.product.productBaseCost * (this.product.product.gainMargin / 100));
        this.product.product.productSellPrice =
        sellprice + (sellprice * (this.taxSelected.taxValue/100));
        this.product.product.productSellPrice
      }else{
        this.product.product.productSellPrice =
          this.product.product.productBaseCost +
          this.product.product.productBaseCost * (this.product.product.gainMargin / 100);
      }
    }else{
      this.product.product.productSellPrice = this.product.product.productBaseCost
    }
  }

  changeShopPoint(){
    const listContainer = this.el.nativeElement.querySelector('#itemCombinationList');
    const quantityInputs = listContainer.querySelectorAll('.quantityInput');
    const quantityMainInputs = listContainer.querySelectorAll('.quantityMain');

    quantityMainInputs.forEach((element:any) => {
      let sum = 0;

      const neighboringInputs = element.parentNode.querySelectorAll('input.quantityInput');

      neighboringInputs.forEach((input: any) => {
        if (!input.classList.contains('quantityMain')) {
          sum += parseInt(input.value);
        }
      });

      element.value = this.productType == 2 ? "Ilimitado" :sum.toString();
    })

    // quantityInputs.forEach((element:any) => {


    //   const dataShopPoint = element.getAttribute('data-shopPoint');
    //   if (dataShopPoint === this.activeShopPoint) {
    //     element.classList.remove('visually-hidden');
    //   } else {
    //     element.classList.add('visually-hidden');
    //   }
    // });
  }

  toggleItemRelationship(itemId: number, relation: string) {
    const itemIndex = this.items.findIndex((item: { itemId: number; }) => item.itemId === itemId);
    if (itemIndex > -1) {
      if (!this.items[itemIndex].itemRelationship) {
        this.items[itemIndex].itemRelationship = [];
      }
      const relationIndex = this.items[itemIndex].itemRelationship.indexOf(relation);
      if (relationIndex > -1) {
        this.items[itemIndex].itemRelationship.splice(relationIndex, 1);
      } else {
        this.items[itemIndex].itemRelationship.push(relation);
      }
    }
   // console.log(`Parentescos actualizados para ítem ${itemId}:`, this.items[itemIndex].itemRelationship);
  }

  changeProductType(event: Event) {
    const element = event.target as HTMLSelectElement;
    this.productType = parseInt(element.value);
  }

  changeSesions(event: Event){
    const element = event.target as HTMLInputElement;
    if(element.value == ""){
      this.product.product.productSessions = 0;
    }else{
      this.product.product.productSessions = parseInt(element.value);
    }
  }

  revenueValue() {
    let revenue = parseFloat(this.product.product.productSellPrice) * (this.taxSelected.taxValue/100);
    return revenue.toFixed(2);
  }

  getNewItemImages(itemId: number) {
    const specific = this.generalImages.find((image: any) => image.items.includes(itemId));
    if (specific) {
      return this.getItemImages(specific.url.split('?')[0].replace('-small.', '-size.'), 0, 1);
    }
    const images = this.generalImages.filter((image: any) =>
      image.isGeneral === 1 || image.persistedImages?.[itemId]
    );
    return images.flatMap((image: any, index: number) => {
      if (image.persistedImages?.[itemId]) return image.persistedImages[itemId];
      return this.getItemImages(image.url.split('?')[0].replace('-small.', '-size.'), 1, index + 1);
    });
  }

  private loadImageAssociations(items: any[]): void {
    const images = new Map<string, any>();
    for (const item of items) {
      for (const image of item.images?.small || []) {
        const url = image.imageURL?.split('?')[0];
        if (!url) continue;
        const entry = images.get(url) || { url, items: [], isGeneral: 0 };
        if (Number(image.isGeneral) === 1) entry.isGeneral = 1;
        if (image.isGeneral !== undefined && image.isGeneral !== null && Number(image.isGeneral) === 0) {
          if (!entry.items.includes(item.itemId)) entry.items.push(item.itemId);
        } else if (image.isGeneral === undefined || image.isGeneral === null) {
          // Preserve unclassified associations rather than guessing from image count.
          entry.persistedImages = entry.persistedImages || {};
          entry.persistedImages[item.itemId] = Object.entries(item.images).flatMap(([imageType, variants]: [string, any]) =>
            (variants || []).filter((variant: any) =>
              variant.imageURL?.split('?')[0].replace(/-(main|medium|small|thumbnail)\./, '-size.') ===
              url.replace('-small.', '-size.')
            ).map((variant: any) => ({ ...variant, imageType, imageURL: variant.imageURL.split('?')[0] }))
          );
        }
        images.set(url, entry);
      }
    }
    this.generalImages = Array.from(images.values());
  }

  normalizeProductFiles(product: any): ProductPdfFile[] {
    return normalizeProductFiles(product);
  }

  addPdfRow(): void {
    this.productFiles.push(createEmptyProductPdfFile(this.productFiles.length + 1));
    this.syncProductFileTranslationRows();
  }

  removePdfRow(index: number): void {
    const pdf = this.productFiles[index];
    if (!pdf) {
      return;
    }

    this.queueProductPdfFileDelete(pdf);

    if (pdf.url?.startsWith('blob:')) {
      URL.revokeObjectURL(pdf.url);
    }

    this.englishTranslation.productFiles.splice(index, 1);
    this.initialEnglishTranslation.productFiles.splice(index, 1);
    this.productFiles.splice(index, 1);
    this.reorderPdfRows();
    this.syncProductFileTranslationRows();
  }

  onPdfSelected(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      if (file.type !== 'application/pdf') {
        alert('Por favor, selecciona un archivo PDF.');
        this.clearPdfSelection(index);
        input.value = '';
        return;
      }

      if (file.size > PDF_MAX_SIZE_BYTES) {
        $('#errorProductModal').modal('show');
        this.clearPdfSelection(index);
        input.value = '';
        return;
      }

      const current = this.productFiles[index];
      this.queueProductPdfFileDelete(current);

      if (current?.url?.startsWith('blob:')) {
        URL.revokeObjectURL(current.url);
      }

      this.productFiles[index] = {
        ...current,
        file,
        fileName: file.name,
        url: URL.createObjectURL(file),
        s3Key: undefined,
        sortOrder: index + 1,
        isNew: true,
        isLegacy: false,
      };
      this.syncProductFileTranslationRows();
    }
  }

  openPdfFile(pdf: ProductPdfFile): void {
    if (!pdf.url) {
      alert('No se encontro una fuente valida para el PDF.');
      return;
    }

    this.pdfPreviewUrl = pdf.url;
    this.pdfPreviewTitle = pdf.label || pdf.fileName || 'PDF';
    this.pdfPreviewSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdf.url);
    $('#editPdfPreviewModal').modal('show');
  }

  openPdfInNewTab(): void {
    const firstPdf = this.productFiles.find((pdf) => !!pdf.url);
    if (firstPdf) {
      this.openPdfFile(firstPdf);
    }
  }

  openPdfPreviewInNewTab(): void {
    if (this.pdfPreviewUrl) {
      window.open(this.pdfPreviewUrl, '_blank');
    }
  }

  closePdfPreview(): void {
    $('#editPdfPreviewModal').modal('hide');
    this.pdfPreviewSafeUrl = null;
    this.pdfPreviewUrl = null;
    this.pdfPreviewTitle = '';
  }

  async saveProductFiles(): Promise<ProductPdfFilePayload[] | null> {
    const validation = validateProductPdfFiles(this.productFiles);
    if (!validation.valid) {
      alert(validation.message || 'Revise los archivos PDF del producto.');
      return null;
    }

    const uploadedProductFiles: ProductPdfFile[] = [];
    for (const [index, pdf] of this.productFiles.entries()) {
      if (!pdf.file) {
        uploadedProductFiles.push({ ...pdf, sortOrder: index + 1 });
        continue;
      }

      const ext = getFileExtension(pdf.file);
      const filePath = `${this.shopTheme?.[0]?.shopId}/${environment.stage}/products-pdf/pdf${Date.now()}-${index + 1}.${ext}`;
      const data: any = await this.lambdaService.uploadFile(filePath, pdf.file, {});

      uploadedProductFiles.push({
        ...pdf,
        url: data.imageURL || '',
        s3Key: filePath,
        fileName: pdf.fileName || pdf.file.name,
        sortOrder: index + 1,
        isNew: false,
        isLegacy: false,
      });
    }

    this.productFiles = uploadedProductFiles;
    this.syncProductFileTranslationRows();
    return this.buildProductFilesPayload();
  }

  buildProductFilesPayload(): ProductPdfFilePayload[] {
    return buildProductFilesPayload(this.productFiles);
  }

  private clearPdfSelection(index: number): void {
    const current = this.productFiles[index];
    if (!current) {
      return;
    }

    if (current.url?.startsWith('blob:')) {
      URL.revokeObjectURL(current.url);
    }

    this.productFiles[index] = {
      ...current,
      file: undefined,
      fileName: current.isLegacy ? current.fileName : undefined,
      url: current.isLegacy ? current.url : undefined,
      s3Key: current.isLegacy ? current.s3Key : undefined,
      isNew: !current.isLegacy,
    };
    this.syncProductFileTranslationRows();
  }

  private queueProductPdfFileDelete(pdf?: ProductPdfFile): void {
    if (!pdf || pdf.isLegacy || pdf.file || !pdf.s3Key) {
      return;
    }

    if (!this.productPdfFilesToDelete.includes(pdf.s3Key)) {
      this.productPdfFilesToDelete.push(pdf.s3Key);
    }
  }

  private reorderPdfRows(): void {
    this.productFiles = this.productFiles.map((pdf, index) => ({
      ...pdf,
      sortOrder: index + 1,
    }));
  }

  private ensureProductFileTranslation(index: number): ProductFileTranslationValue {
    this.syncProductFileTranslationRows();
    return this.englishTranslation.productFiles[index];
  }

  private syncProductFileTranslationRows(): void {
    const existing = this.englishTranslation.productFiles || [];
    this.englishTranslation = {
      ...this.englishTranslation,
      productFiles: this.productFiles.map((pdf, index) => {
        const current = existing[index];
        const label = current?.label || {
          value: pdf.translatedLabel || pdf.label || '',
          manual: false,
        };

        return {
          label,
          url: pdf.url,
          fileName: pdf.fileName,
          s3Key: pdf.s3Key,
          sortOrder: index + 1,
        };
      }),
    };

    this.initialEnglishTranslation = {
      ...this.initialEnglishTranslation,
      productFiles: this.productFiles.map((pdf, index) => {
        const current = this.initialEnglishTranslation.productFiles?.[index];
        return {
          label: current?.label || { value: pdf.label || '', manual: false },
          url: pdf.url,
          fileName: pdf.fileName,
          s3Key: pdf.s3Key,
          sortOrder: index + 1,
        };
      }),
    };
  }

  private async deleteQueuedProductPdfFiles(): Promise<void> {
    const keys = [...this.productPdfFilesToDelete];
    this.productPdfFilesToDelete = [];

    await Promise.all(
      keys.map((s3Key) =>
        this.lambdaService.deleteFile(s3Key).catch((error: any) => {
          console.error('Error al eliminar el archivo PDF de S3:', error);
        })
      )
    );
  }

  async saveChanges() {
    if (this.imagesBusy) return;
    if(this.validateValues()){
      $('#validationModal').modal({ backdrop: 'static', keyboard: false });
      $('#validationModal').modal('show');
      return;
    }
    const externalRedirectActive = this.isExternalRedirectActive();
    if (this.product?.product?.externalRedirectEnabled && !externalRedirectActive) {
      this.externalUrlError = true;
      return;
    }
    //si propducto tipo paquete y no posee productos asociados, no se permite crear el producto
    if (this.product.product.productType === 4 && this.productPackageItems.length === 0) {
      $('#errorPPCreateModal').modal('show');
      return;
    }
    $('#productModal').modal({ backdrop: 'static', keyboard: false });
    $('#productModal').modal('show');

    // console.log(this.product);
    // let imageURLs: any[] = [];


    // getItemImages

    //.log(imageURLs);

    let items = [];

    for (let item of this.items) {
      items.push({
        itemId: item.itemId,
        itemCode: item.itemCode,
        itemActive: item.itemActive,
        itemPrice: item.itemPrice,
        itemDiscountPrice: item.itemDiscountPrice,
        itemSessions: item.itemSessions,
        itemBeneficiaries: item.itemBeneficiaries,
        itemHolder: item.itemHolder,
        itemQuantity: item.itemQuantity,
        itemShopPoints: item.itemShopPoints,
        itemVariantValues: item.variantValues,
        imageURLs: this.getNewItemImages(item.itemId),
        itemRelationship: item.itemRelationship
      });
    }

      this.loading = true;
      this.savingImages = true;

      try {
          const productFilesPayload = await this.saveProductFiles();
          if (productFilesPayload === null) {
            $('#productModal').modal('hide');
            this.loading = false;
            return;
          }
          const productTranslate = this.resolveProductTranslatePayload();
          this.productFile = this.product.product.productFile || '';

          const response: any = await this.lambdaService.updateProduct(
              this.product.product.productId,
              this.themingService.shopId,
              encodeURI(this.product.product.productDescription),
              this.product.product.productIsActive == true ? 1 : 0,
              items,
              this.product.product.productName,
              this.product.product.productCategoryId,
              this.product.product.productSubCategoryId,
              this.product.product.productSubSubCategoryId,
              this.product.product.productIndustryTypeId,
              this.product.product.productSupplierId == null ? 0 : this.product.product.productSupplierId,
              this.product.product.productCollectionId == null ? 0 : this.product.product.productCollectionId,
              this.product.product.productBaseCost,
              this.product.product.productTaxId,
              this.product.product.productSellPrice,
              this.discountPrice > 0 ? this.discountPrice: 0,
              this.variants,
              new Date().toLocaleString('en-US', {
                  timeZone: 'America/Costa_Rica',
              }),
              this.deleteItems,
              this.product.product.productType,
              this.product.product.productSessions,
              this.productFile,
              productFilesPayload,
              this.productPackageItems,
              encodeURI(this.product.product.productConditions),
              this.product.product.externalUrl ? this.product.product.externalUrl.trim() : null,
              externalRedirectActive,
              this.product.product.hidePrice,
              this.product.product.productPaymentMode,
              productTranslate as any, // Forzar el tipo para compatibilidad legacy,
              this.product.product.productContribution,
              this.product.product.productContributionType,
              this.product.product.productContributionCurrency,
              this.product.product.productGracePeriod,
              this.product.product.productSessionRenewalPeriod
          );

          if (response.statusCode === 200) {
              await this.deleteQueuedImageFiles();
              await this.deleteQueuedProductPdfFiles();
              await this.loadProduct();
              $('#productModal').modal('hide');
              $('#successEditProductModal').modal('show');
          } else {
              $('#errorEditProductModal').modal('show');
              console.error('Update failed');
          }
      } catch (error) {
          $('#errorEditProductModal').modal('show');
          console.error('Error occurred during update:', error);
      } finally {
          this.savingImages = false;
          this.loading = false;
          $('#productModal').modal('hide');
      }
  }

  closeModal(){
    $('#successEditProductModal').modal('hide');
    $('#validationModal').modal('hide');
    $('#selectImagesModal').modal('hide');
    $('#productsModal').modal('hide');
    $('#errorEditProductModal').modal('hide');
    $('#errorProductModal').modal('hide');
    $('#errorPPCreateModal').modal('hide');
  }

  findIndexToUpdate(newItem: any) {
    return newItem.id === this;
  }

  // changeItemcode(event: Event){
  //   const element = event.target as HTMLInputElement;
  //   let parentId = element.parentElement?.parentElement?.id;
  //   let arrayIndex = this.items.findIndex((item: { itemId: any}) => item.itemId == parentId)

  //   //let itemEdited = this.items[arrayIndex];
  //   this.items[arrayIndex].itemCode = element.value;

  //   return this.items[arrayIndex].itemCode;
  // }

  changeItemcode(event: Event){
    const element = event.target as HTMLInputElement;
    let itemId = element.getAttribute('data-itemId');
    let arrayIndex = this.items.findIndex((item: { itemId: any}) => item.itemId == itemId)

    this.items[arrayIndex].itemCode = element.value;

    return this.items[arrayIndex].itemCode;
  }

  // changeitemQuantity(event: Event){
  //   const element = event.target as HTMLInputElement;
  //   let parentId = element.parentElement?.parentElement?.id;
  //   let arrayIndex = this.items.findIndex((item: { itemId: any}) => item.itemId == parentId)

  //   const shopPointId = this.items[0].itemShopPoints.shopPointId;
  //   this.items[arrayIndex].itemQuantity = parseInt(element.value);
  //   this.items[arrayIndex].itemShopPoints = {shopPointId, itemQuantity: parseInt(element.value)};
  // }

  changeitemShopPointQuantity(event: Event){
    const element = event.target as HTMLInputElement;
    let shopPointId = element.getAttribute('data-shoppoint');
    let itemId = element.getAttribute('data-itemId');
    let arrayIndex = this.items.findIndex((i: { itemId: any}) => i.itemId == itemId)
    const item = this.items[arrayIndex];
    if (item) {
        let arrayIndex = item.itemShopPoints.findIndex((sp: { shopPointId: any}) => sp.shopPointId == shopPointId)
        const shopPoint = item.itemShopPoints[arrayIndex];
        const unlimitedSelect = this.el.nativeElement.querySelector(`.no-variant-unlimited[data-shoppoint="${shopPointId}"]`);
        if (shopPoint) {
            shopPoint.itemQuantity = parseInt(element.value);
            shopPoint.itemUnlimited = parseInt(unlimitedSelect.value) || 0;
        }
    }
  }

  changeitemShopPointUnlimited(event: Event){
    const element = event.target as HTMLInputElement;
    let shopPointId = element.getAttribute('data-shoppoint');
    let itemId = element.getAttribute('data-itemId');
    let arrayIndex = this.items.findIndex((i: { itemId: any}) => i.itemId == itemId)
    const item = this.items[arrayIndex];
    if (item) {
        let arrayIndex = item.itemShopPoints.findIndex((sp: { shopPointId: any}) => sp.shopPointId == shopPointId)
        const shopPoint = item.itemShopPoints[arrayIndex];
        const inputQuantity = this.el.nativeElement.querySelector(`.no-variant-quantity[data-shoppoint="${shopPointId}"]`);
        inputQuantity.value = 0;
        inputQuantity.disabled = !inputQuantity.disabled;
        if (shopPoint) {
            shopPoint.itemQuantity = parseInt(inputQuantity.value);
            shopPoint.itemUnlimited = parseInt(element.value);
        }
    }
  }

  changeitemPrice(event: Event){
    const element = event.target as HTMLInputElement;
    let itemId = element.getAttribute('data-itemId');
    let arrayIndex = this.items.findIndex((item: { itemId: any}) => item.itemId == itemId)
    this.items[arrayIndex].itemPrice = element.value;
    //return element.value;
  }

  changeitemDiscountPrice(event: Event){
    const element = event.target as HTMLInputElement;
    let itemId = element.getAttribute('data-itemId');
    let arrayIndex = this.items.findIndex((item: { itemId: any}) => item.itemId == itemId)
    this.items[arrayIndex].itemDiscountPrice = element.value;
  }

  changeitemBeneficiaries(event: Event){
    const element = event.target as HTMLInputElement;
    let itemId = element.getAttribute('data-itemId');
    let arrayIndex = this.items.findIndex((item: { itemId: any}) => item.itemId == itemId)
    this.items[arrayIndex].itemBeneficiaries = element.value;
  }

  changeitemSessions(event: Event){
    const element = event.target as HTMLInputElement;
    let itemId = element.getAttribute('data-itemId');
    let arrayIndex = this.items.findIndex((item: { itemId: any}) => item.itemId == itemId)
    this.items[arrayIndex].itemSessions = element.value;
  }

  changeItemHolder(event: Event){
    const element = event.target as HTMLInputElement;
    let itemId = element.getAttribute('data-itemId');
    let arrayIndex = this.items.findIndex((item: { itemId: any}) => item.itemId == itemId)
    this.items[arrayIndex].itemHolder = element.checked ? 1 : 0;
  }

  changeVariantTypeName(event: Event){
    const element = event.target as HTMLInputElement;
    let arrayIndex = element?.id;
    let index = parseInt(arrayIndex.replace("type", ""));

    this.variants[index].variantTypeName = element.value;
    return element.value;
  }

  changeVariantValue(event: Event){
    const element = event.target as HTMLInputElement;
    let arrayIndex = element?.name;
    let variantIndex = parseInt(arrayIndex.replace("type", ""));
    let elementIndex = element?.id;
    let variantValueIndex = parseInt(elementIndex.replace("id", ""));

    if (!element?.value) return;
    const nameExists = this.variants[variantIndex].variantValues.some((item: any) => item.variantValueName === element?.value)
    if(nameExists){
      element.classList.add('duplicated');
      this.duplicatedVariants = true;
      this.enabledSave = false;
      // console.log("Nombre de variante repetido");
      // const editetValues = this.variants[variantIndex].variantValues.map((item: any) => {
        //   if(item.variantValueName === element?.value){
          //     item.variantValueName = ''
          //     this.updateItemVariants(element?.value, '');
          //   }
          //   return item
          // })
          // this.variants[variantIndex].variantValues = editetValues
          // console.log(editetValues)
      }else{
        element.classList.remove('duplicated');
        this.duplicatedVariants = false;
        this.enabledSave = true;
        let name = this.variants[variantIndex].variantValues[variantValueIndex].variantValueName;
        this.updateItemVariants(name, element.value);
        this.variants[variantIndex].variantValues[variantValueIndex].variantValueName = element.value;
      }
    const emptyValue = this.variants[variantIndex].variantValues.some((item: any) => item.variantValueName == "");
    if(!emptyValue){
      this.emptyVariantValue = false;
    }
    return element.value;
  }

  updateItemVariants(name: string, newName: string){
    for (let item of this.items) {
      for (let variantValue of item.variantValues) {
        if(variantValue.variantValueName == name){
          variantValue.variantValueName = newName;
        }
      }
    }
  }

  /**
   * The function checks if any of the items in an array have empty values and returns true if at least
   * one item has empty values.
   * @returns a boolean value. It returns `true` if any of the items in the `items` array have empty
   * values, and `false` otherwise.
   */
  validateValues(){
    for (const item of this.items) {
      if(this.hasEmptyValues(item)){
        return true;
      }
    }
    return false;
  }

  /**
   * This function checks if an object has empty values in its variantValues property.
   * @param {any} item - The `item` parameter is an object that contains information about a product
   * variant, including its variant values.
   * @returns The function `hasEmptyValues` returns a boolean value. It returns `false` if the `item`
   * parameter does not have a `variantValues` property, and it returns `true` if any of the objects in
   * the `variantValues` array have an empty `variantValueName` property.
   */
  hasEmptyValues(item: any) {
    if(!item.variantValues){
      return false;
    }
    return item.variantValues.some((obj: any) => obj.variantValueName === '')
  }

  /**
   * This function adds a new variant object to an array of variants.
   */
  addVariant(){
    this.variants.push({
      variantTypeName: '',
      variantValues: []
    })
  }

  /**
   * This function adds a new variant value to a product's variant and updates the corresponding items
   * with the new variant value.
   * @param {number} variantIndex - The index of the variant in the variants array to which a new
   * variant value will be added.
   */
  addVariantValue(variantIndex: number){
    const position = this.variants[variantIndex].variantValues.reduce((value:number, currentValue:any) => {
      return currentValue.variantValuePosition > value ? currentValue.variantValuePosition : value;
    }, 0)+1;

    const variantValueId = position*-1

    const updatedVariantValues = this.variants[variantIndex].variantValues.concat([{
      variantValueId,
      variantValueName: '',
      variantValuePosition: position
    }]);
    const updatedVariant = this.variants[variantIndex];
    updatedVariant.variantValues = updatedVariantValues;
    this.variants[variantIndex] = updatedVariant;

    const joinedVariants = this.joinVariants();

    for (const [index, value] of joinedVariants.entries()) {
      if(!this.items[index]){
        let itemShopPoints: any[] = [];
        let totalStock = 0;
        this.shopPoints.forEach((shopPoint: any) => {
          itemShopPoints.push(
            {
              shopPointId: shopPoint.shopPointId,
              itemQuantity: 0,
              itemUnlimited: 0
            }
          )
        });
        this.items.push({
          itemId: this.items.length * -1,
          itemActive: 1,
          itemCode: `${this.product.product.productCode}${this.items.length}`,
          itemPrice: this.items[this.items.length -1].itemPrice,
          itemQuantity: 10,
          itemSessions: 0,
          itemBeneficiaries: 0,
          itemDiscountPrice: 0,
          itemShopPoints: itemShopPoints,
          itemTotalStock: totalStock,
          itemHolder: 0,
          itemRelationships: [],
      })
      }
      this.items[index].variantValues = value;
    }
    this.emptyVariantValue = true;
  }

  /**
   * The function joins variant values from an array of variants into a new array of all possible
   * combinations.
   * @returns The `joinVariants()` function is returning an array of all possible combinations of
   * variant values from the `variants` array. Each combination is represented as an array of objects,
   * where each object contains the `variantValueName` property.
   */
  joinVariants(){
    const arrays:any = []

    for (const variant of this.variants) {
      let arr: any = []
      for (const value of variant.variantValues) {
        arr.push({
          variantValueName: value.variantValueName
        })
      }
      arrays.push(arr)
    }

    const result = arrays.reduce((acc: any, arr: any) => {
      return acc.flatMap((item: any) => arr.map((elem: any) => [...item, elem]));
    }, [[]]);

    return result;
  }

  /**
   * The function deletes items from an array based on a specific variant value name and stores the
   * deleted item IDs in a separate array.
   * @param {any} variantValueName - The parameter variantValueName is a variable that represents the
   * name of a variant value that needs to be deleted from the items array.
   */
  deleteItem(variantValueName: any){
    const items = this.items.filter((item: any) => !item.variantValues.some((obj: any) => obj.variantValueName === variantValueName));
    const itemsDeleted = this.items.filter((item: any) => item.variantValues
                                    .some((item: any) => item.variantValueName === variantValueName))
                                    .map((item: any) => item.itemId);
    this.deleteItems = this.deleteItems.concat(itemsDeleted);
    this.items = items;
  }

  /**
   * This function deletes a variant and all its associated variant values from an array of variants.
   * @param {number} variantIndex - The index of the variant to be deleted from the `variants` array.
   */
  deleteVariant(variantIndex: number) {
    const deletedVariant = this.variants[variantIndex];
    for(const [i,v] of deletedVariant.variantValues.entries()){
      this.deleteVariantValue(variantIndex, v.variantValueId)
    }
    this.variants = this.variants.filter(item => item !== deletedVariant)
    const emptyValue = this.variants[variantIndex].variantValues.some((item: any) => item.variantValueName == "");
    if(!emptyValue || this.variants.length == 0){
      this.emptyVariantValue = false;
    }
  }

  /**
   * This function deletes a variant item from a list of items based on its variant value name.
   * @param {any} variantValueName - The parameter `variantValueName` is a variable of type `any` that
   * represents the name of the variant value that needs to be deleted from the items list.
   */
  deleteVariantItem(variantValueName: any){
    if(this.items.length == 1){
      this.items[0].itemCode = this.product.product.productCode+0;
    }
    const items = this.items.map((item: any) => {
      const variantValues = item.variantValues.filter((item: any) => item.variantValueName !== variantValueName);
      item.variantValues = variantValues;
      return item
    });
    this.items = items;
  }

  /**
   * This function deletes a variant value from a variant and updates the variant accordingly.
   * @param {number} variantIndex - The index of the variant in the variants array that contains the
   * variant value to be deleted.
   * @param {number} variantValueId - The ID of the variant value that needs to be deleted.
   */
  deleteVariantValue(variantIndex: number, variantValueId: number){
    const variantValueName = this.variants[variantIndex].variantValues.find((item: any) => item.variantValueId === variantValueId).variantValueName;
    const updatedVariantValues = this.variants[variantIndex].variantValues.filter((item: any) => item.variantValueId !== variantValueId);
    const updatedVariant = this.variants[variantIndex];
    updatedVariant.variantValues = updatedVariantValues;
    if(updatedVariant.variantValues.length === 0){
      this.deleteVariant(variantIndex);
    }else{
      this.variants[variantIndex] = updatedVariant;
      this.deleteItem(variantValueName);
    }
    this.deleteVariantItem(variantValueName)
    const emptyValue = this.variants[variantIndex].variantValues.some((item: any) => item.variantValueName == "");
    if(!emptyValue){
      this.emptyVariantValue = false;
    }
  }


  /**
   * The function concatenates the names of variant values of an item and returns the resulting string,
   * or returns the item ID if there are no variant values.
   * @param {any} item - The parameter "item" is of type "any", which means it can be any data type
   * (string, number, object, etc.). It is used as input to the function "objectValueJoin".
   * @returns The function `objectValueJoin` takes an argument `item` and returns a string. If the
   * `item` does not have a property `variantValues`, then the function returns the `itemId` property
   * of the `item`. Otherwise, the function reduces the `variantValues` array of the `item` to a single
   * string by concatenating the `variantValueName` property of each element,
   */
  objectValueJoin(item: any): string{
    if(!item.variantValues || item.variantValues.length === 0){
      return item.itemId
    }
    const data = item.variantValues.map((item: any) => item.variantValueName).join('/')
    return data
  }

}
